import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import Seo from "../seo/Seo";
import { Section, CTASection } from "../components/ui-kit";
import { SITE_URL, RESOURCES, BUSINESS } from "../data/site";

const ResourceArticle = () => {
  const { slug } = useParams();
  const a = RESOURCES.find((r) => r.slug === slug);
  if (!a) return <Navigate to="/resources" replace />;
  const breadcrumbs = [{ name: "Home", path: "/" }, { name: "Resources", path: "/resources" }, { name: a.title, path: `/resources/${a.slug}` }];
  const schema = {
    "@context": "https://schema.org", "@type": "Article", headline: a.title,
    description: a.excerpt, author: { "@type": "Organization", name: BUSINESS.name },
    publisher: { "@type": "Organization", name: BUSINESS.name, logo: { "@type": "ImageObject", url: BUSINESS.logo } },
    mainEntityOfPage: `${SITE_URL}/resources/${a.slug}`,
  };
  return (
    <>
      <Seo title={`${a.title} | Build Highland Homes`} description={a.excerpt} path={`/resources/${a.slug}`} breadcrumbs={breadcrumbs} schema={schema} />
      <Section className="bg-[#0b0b0b] pt-40 md:pt-48">
        <div className="max-w-3xl mx-auto">
          <Link to="/resources" className="text-sm text-[#c9a24b] hover:text-[#e3c77a]">← All Resources</Link>
          <span className="block text-[#c9a24b] text-[10px] tracking-[0.2em] uppercase mt-6">{a.category}</span>
          <h1 className="font-serif-display text-4xl md:text-5xl text-[#f3ede0] mt-2 mb-8 leading-tight">{a.title}</h1>
          <div className="gold-divider w-40 mb-8" />
          <div className="space-y-5">
            {a.body.map((p, i) => <p key={i} className="text-[#cfc8b8] leading-relaxed text-lg">{p}</p>)}
          </div>
        </div>
      </Section>
      <CTASection />
    </>
  );
};

export default ResourceArticle;
